import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, SearchIcon } from 'lucide-angular';

@Component({
  selector: 'allas-search-input',

  imports: [CommonModule, LucideAngularModule],
  template: `
    <div class="relative">
      <input
        #searchInput
        type="text"
        [placeholder]="placeholder"
        [value]="searchValue"
        (input)="onInput($event)"
        (keydown.enter)="onEnter()"
        (focus)="onFocus()"
        (blur)="onBlur()"
        class="w-full outline-none focus:outline-1 focus:outline-blue-300 px-4 py-3 pr-12 border border-gray-200 rounded-xl bg-white hover:bg-gray-50 text-gray-700 placeholder:text-gray-500 focus:bg-white focus:border-blue-300 h-12 transition-all duration-200"
      />
      <button
        (click)="onSearchClick()"
        class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-blue-600 transition-colors p-1 rounded-md hover:bg-blue-50"
      >
        <lucide-icon [name]="searchIcon" class="w-5 h-5"></lucide-icon>
      </button>
    </div>
  `,
})
export class SearchInputComponent implements AfterViewInit {
  @Input() searchValue: string = '';
  @Input() placeholder: string = 'Buscar repuestos...';
  @Input() autofocus: boolean = false;

  @Output() searchChange = new EventEmitter<string>();
  @Output() searchSubmit = new EventEmitter<string>();
  @Output() inputFocus = new EventEmitter<void>();
  @Output() inputBlur = new EventEmitter<void>();

  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  readonly searchIcon = SearchIcon;

  ngAfterViewInit() {
    if (this.autofocus) {
      setTimeout(() => {
        this.searchInput.nativeElement.focus();
      }, 100);
    }
  }

  onInput(event: any): void {
    const value = event.target.value;
    this.searchChange.emit(value);
  }

  onEnter(): void {
    this.searchSubmit.emit(this.searchValue);
  }

  onSearchClick(): void {
    this.searchSubmit.emit(this.searchValue);
  }

  onFocus(): void {
    this.inputFocus.emit();
  }

  onBlur(): void {
    this.inputBlur.emit();
  }

  focus(): void {
    this.searchInput.nativeElement.focus();
  }
}
